import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const LiveAgentSetting: FormizoSchema[] = [
  {
    header: "Retain Customer",
  },
  {
    label: "Prompt customer to ask question before Live Chat redirection take place",
    name: "SettingDoc.Config.RetainCustomer",
    format: "bool",
    boolStyle: "switch",
  },
  {
    header: "Retain Message",
  },
  {
    label: "EN",
    name: "RetainMessage.text.EN",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    label: "TC",
    name: "RetainMessage.text.TC",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    label: "SC",
    name: "RetainMessage.text.SC",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    header: "Category",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.Category.EN",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.Category.TC",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.Category.SC",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    header: "Session Expiry Time",
  },
  {
    label: "(mins)",
    name: "SettingDoc.Config.SessionExpiryTime",
    format: "number",
    variant: "outlined",
  },
  {
    header: "URL",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.URL.EN",
    format: "text",
    variant: "outlined",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.URL.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.URL.SC",
    format: "text",
    variant: "outlined",
  },
  {
    header: "No Service Message",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.Message.NoService.EN",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.Message.NoService.TC",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.Message.NoService.SC",
    format: "textarea",
    rows: 3,
    variant: "outlined",
  },
  {
    header: "Service Availability Setting",
  },
  {
    label: "Service 24hr Available",
    name: "SettingDoc.Config.Service24HRAvailable",
    format: "bool",
    boolStyle: "switch",
  },
  {
    label: "Non-service day list",
    name: "SettingDoc.Config.NonServiceDayList",
    format: "textarea",
    rows: 2,
    variant: "outlined",
  },
  {
    header: "Opening Hour",
  },
  {
    label: "From",
    name: "SettingDoc.Config.OpeningHour.From",
    format: "date",
    dateFormat: "HH:mm",
    dateType: "time",
  },
  {
    label: "To",
    name: "SettingDoc.Config.OpeningHour.To",
    format: "date",
    dateFormat: "HH:mm",
    dateType: "time",
  },
];
